import { Platform, StyleSheet, ViewStyle } from "react-native";

const style = StyleSheet.create({
  // Lets a short screen fill the scroll viewport so its content can centre vertically.
  // flexGrow rather than flex: flex would cap the height and stop long screens scrolling.
  contentContainer: {
    flexGrow: 1,
  },
  footer: {
    bottom: 0,
    position: "absolute",
  },
  header: {
    ...Platform.select({
      web: {
        position: "sticky",
      },
    }),
  } as ViewStyle,
});

export { style };
